import {get} from './request'
import {AppConfigDraftDetail, AppConfigPageDetail} from "@/model/AppConfig";
import {IdResult} from "@/model/IdResult";
import {AppConfigGlobalMenu, AppConfigGlobalMenuModule} from "@/model/AppConfigGlobalMenu";

const proxyUrl = process.env.VUE_APP_BASE_URL + '/app_config'

export default {
    pcHomePageId: (): Promise<IdResult> => get(`${proxyUrl}/pages/pc_home_page_id`),
    detail: (id: string): Promise<AppConfigPageDetail> => get(`${proxyUrl}/pages/one?id=${id}`),
    globalMenus: (module: AppConfigGlobalMenuModule): Promise<AppConfigGlobalMenu[]> => get(`${proxyUrl}/global_menus`, {module})
}
